(function() {
    'use strict';

    angular.module('page.constants', [])
        .constant('pageMessagesConst', {
            add: 'Dodano nową stronę!',
            update: 'Dane strony zostały zaktualizowane!',
            delete: 'Strona została usunięta!',
            error: 'Wystąpił bład!'
        })
        .constant('pagePermissionsConst', {
            view: {
                value: 'view_page',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu stron!'
            },
            add: {
                value: 'add_page',
                errorMsg: 'Użytkownik nie ma uprawnień do dodania stron!'
            },
            update: {
                value: 'change_page',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji stron!'
            },
            delete: {
                value: 'delete_page',
                errorMsg: 'Użytkownik nie ma uprawnień do usuwania stron!'
            }
        });
})();
